"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WAIT_FOR_ORDER_LOCAL_STORAGE = exports.defaultCustomFillDelay = exports.STABLE_TOKENS = exports.EXPLORER_URLS = exports.MIN_DURATION_MILLIS_FORMATTED = exports.MIN_DURATION_MILLIS = exports.MAX_DURATION_MILLIS = exports.MAX_TRADE_INTERVAL_FORMATTED = exports.MIN_TRADE_INTERVAL_FORMATTED = exports.MAX_TRADE_INTERVAL = exports.MIN_TRADE_INTERVAL = exports.MIN_CHUNKS = exports.feeOnTransferDetectorAddresses = exports.AMOUNT_TO_BORROW = exports.SUGGEST_CHUNK_VALUE = exports.QUERY_PARAMS = exports.ORDERS_CONTAINER_ID = exports.MIN_NATIVE_BALANCE = exports.STALE_ALLOWANCE = exports.REFETCH_GAS_PRICE = exports.REFETCH_BALANCE = exports.REFETCH_USD = exports.REFETCH_ORDER_HISTORY = void 0;
var types_1 = require("./types");
exports.REFETCH_ORDER_HISTORY = 40000;
exports.REFETCH_USD = 15000;
exports.REFETCH_BALANCE = 15000;
exports.REFETCH_GAS_PRICE = 15000;
exports.STALE_ALLOWANCE = 15000;
exports.MIN_NATIVE_BALANCE = 0.01;
exports.ORDERS_CONTAINER_ID = "twap-orders-container";
exports.QUERY_PARAMS = {
    TRADE_INTERVAL: "twap-interval",
    MAX_DURATION: "twap-duration",
    LIMIT_PRICE: "twap-limit",
    INPUT_AMOUNT: "twap-input",
    TRADES_AMOUNT: "twap-trades",
    LIMIT_PRICE_INVERTED: "twap-inverted-limit",
};
exports.SUGGEST_CHUNK_VALUE = 100;
exports.AMOUNT_TO_BORROW = 10000; // smallest amount that has full precision over bps
exports.feeOnTransferDetectorAddresses = {
    1: "0xe9200516a475b9e6FD4D1c452858097F345A6760",
    56: "0x003BD52f589F23346E03fA431209C29cD599d693",
    42161: "0xD8b14F915b1b4b1c4EE4bF8321Bea018E72E5cf3",
    1101: "0xe9200516a475b9e6FD4D1c452858097F345A6760",
    8453: "0xD8b14F915b1b4b1c4EE4bF8321Bea018E72E5cf3",
    324: "0xED87D01674199355CEfC05648d17E037306d7962",
    59144: "0xD8b14F915b1b4b1c4EE4bF8321Bea018E72E5cf3",
};
exports.MIN_CHUNKS = 1;
exports.MIN_TRADE_INTERVAL = 5 * 60 * 1000;
exports.MAX_TRADE_INTERVAL = 30 * 24 * 60 * 60 * 1000;
var millisInADay = 24 * 60 * 60 * 1000;
exports.MIN_TRADE_INTERVAL_FORMATTED = new Date(exports.MIN_TRADE_INTERVAL).getMinutes();
exports.MAX_TRADE_INTERVAL_FORMATTED = exports.MAX_TRADE_INTERVAL / millisInADay;
exports.MAX_DURATION_MILLIS = 30 * 24 * 60 * 60 * 1000;
exports.MIN_DURATION_MILLIS = 5 * 60 * 1000;
exports.MIN_DURATION_MILLIS_FORMATTED = new Date(exports.MIN_DURATION_MILLIS).getMinutes();
exports.EXPLORER_URLS = {
    1: "https://etherscan.io",
    56: "https://bscscan.com",
    137: "https://polygonscan.com",
    43114: "https://snowtrace.io",
    250: "https://ftmscan.com",
    8453: "https://basescan.org",
    42161: "https://arbiscan.io",
};
exports.STABLE_TOKENS = ["usdc", "dai", "usdt", "busd", "tusd", "susd"];
exports.defaultCustomFillDelay = { resolution: types_1.TimeResolution.Minutes, amount: exports.MIN_TRADE_INTERVAL_FORMATTED };
exports.WAIT_FOR_ORDER_LOCAL_STORAGE = "WAIT_FOR_ORDER";
